{
  "breaches": {
    "count": "Seus detalhes de conta foram vazados em {count} violações de dados.",
    "discovered": "Essa violação foi descoberta pela primeira vez em {date}.",
    "empty": {
      "text": "Não encontramos nenhum vazamento de dados em sua conta.",
      "title": "Nenhum vazamento de dados encontrado"
    },
    "high": "Alto",
    "medium": "Médio",
    "title": "Violações",
    "watchlist": {
      "button": "Adicionar email",
      "text": "Emails sendo monitorados",
      "title": "Lista de Observação"
    }
  },
  "cards": {
    "breaches": {
      "text": "Você pode verificar o número de violações de dados em que sua conta foi envolvida nesta página. Nós categorizamos as violações de dados pela sua gravidade e pelo tipo de dados que foi vazado. Certifique-se de mudar suas senhas se seus dados tiverem sido expostos em uma violação de dados.",
      "title": "Os seus dados foram vazados?"
    },
    "overview": {
      "text": "Ei {name}! Como você deve saber, os ataques de phishing estão se tornando cada vez mais complexos e perigosos. O Hub é o lugar para acompanhar seu progresso e aprender ainda mais sobre os ciberataques que ameaçam sua empresa. Complete conquistas de segurança e se torne um especialista em segurança rapidamente.",
      "title": "Bem-vindo ao The Hub!"
    },
    "quiz": {
      "text": "Embarque na jornada interativa do quiz e desafie suas habilidades para distinguir entre e-mails genuínos e de phishing. O quiz foi criado para testar seu conhecimento e compreensão das ameaças que existem no mundo real.",
      "title": "Vamos testar você!"
    },
    "simulations": {
      "text": "Nesta página, você pode ver os detalhes das simulações que recebeu da Moxso nos últimos 90 dias. Ao entender como os e-mails de phishing são projetados, você poderá identificá-los e se proteger deles.",
      "title": "Você foi alvo de phishing?"
    },
    "videos": {
      "text": "Nesta página, você pode assistir a vídeos sobre as últimas ameaças cibernéticas e aprender como se proteger e proteger sua empresa contra elas. Nossos vídeos de treinamento estão disponíveis para você assistir quando quiser.",
      "title": "Preparar, apontar, ação!"
    }
  },
  "certificate": {
    "certificate_of_completion": "Certificado de conclusão",
    "certificate_unlocked": "Certificado desbloqueado",
    "share_on_linkedin": "Compartilhar no LinkedIn",
    "show_certificate": "Mostrar certificado",
    "text": "Você tem um certificado de um curso recente. Por que não o exibe?"
  },
  "courses": {
    "all": "Todos os cursos",
    "completed": {
      "badge": "Concluído",
      "button": "Concluir curso",
      "text": "Você concluiu o curso",
      "title": "Muito bem!"
    },
    "content": {
      "breach": {
        "text": "Ative a detecção de violação para sua conta",
        "title": "Configurar detecção de violação"
      },
      "download": {
        "button": "Baixar"
      },
      "introduction": {
        "contents": "Conteúdos",
        "start": "Iniciar curso",
        "text": "Introdução e visão geral do curso",
        "title": "Introdução"
      },
      "quiz": {
        "choose_answer": "Escolha a resposta correta abaixo:",
        "correct": "Correto",
        "correct_answer": "{label}: {answer}",
        "correct_answer_label": "Resposta correta",
        "next_question": "Próxima pergunta",
        "oh_no": "Que pena!",
        "question_of": "Questão {current} de {total}",
        "result": {
          "text": "Você respondeu corretamente {correct} de {total} perguntas.",
          "title": "Muito bem!",
          "title_fail": "Quase lá!"
        },
        "text": "Coloque suas habilidades à prova com um quiz",
        "title": "Questionário",
        "view_results": "Ver resultado",
        "well_done": "Muito bem!",
        "your_answer": "{label}: {answer}",
        "your_answer_label": "Sua resposta"
      },
      "video": {
        "text": "Aprenda os principais conceitos assistindo a este vídeo"
      }
    },
    "continue": "Continuar",
    "featured": "Cursos em destaque",
    "lessons": "{count} aulas",
    "progress": {
      "button": "Continuar",
      "text": "Você concluiu {pct}% deste curso"
    },
    "skip_video": {
      "button": "Pular",
      "text": "Você já assistiu a este vídeo antes. Deseja pulá-lo?"
    },
    "start_over": "Recomeçar",
    "title": "Cursos"
  },
  "dynamic_keys": {
    "api": {
      "errors": {
        "checksum": "A pergunta expirou",
        "network": "Ocorreu um erro",
        "noResponse": "Nenhuma resposta foi recebida do servidor",
        "streaming": {
          "manifest": "Ocorreu um erro ao reproduzir o vídeo",
          "platform": "Este vídeo não é compatível com o seu dispositivo",
          "unavailable": "Este vídeo não está disponível"
        },
        "unknown": "Ocorreu um erro desconhecido."
      },
      "messages": {
        "auth_failed": "E-mail inválido",
        "csrf": "Atualize a página e tente novamente",
        "email_missing": "Nenhum endereço de email associado à conta",
        "file_not_found": "Arquivo não encontrado",
        "general_exception": "Ocorreu um erro",
        "invalid_answer": "Resposta inválida",
        "invalid_course": "Curso inválido",
        "invalid_domain": "Domínio inválido",
        "invalid_email": "Email inválido",
        "invalid_grant": "Não foi possível contatar o provedor",
        "invalid_locale": "Tradução não encontrada",
        "invalid_option": "Opção inválida",
        "invalid_permissions": "Você não está autorizado a usar este recurso",
        "invalid_point": "Ponto inválido",
        "invalid_provider": "Provedor inválido",
        "invalid_quiz": "Questionário inválido",
        "invalid_token": "Sua sessão expirou",
        "invalid_video": "Vídeo inválido",
        "missing_code": "Por favor, tente novamente.",
        "two_factor_code_expired": "Código de dois fatores expirado",
        "two_factor_code_invalid": "O código de dois fatores é inválido",
        "unauthorized": "Você não está autorizado a usar este recurso.",
        "user_not_found": "O usuário não existe"
      },
      "validations": {
        "messages": {
          "throttle": "Muitas tentativas de login. Por favor, tente novamente mais tarde."
        }
      }
    },
    "breaches": {
      "data_classes": {
        "account_balances": "Saldos de contas",
        "address_book_contacts": "Contatos da agenda",
        "age_groups": "Faixas etárias",
        "ages": "Idades",
        "appointments": "Compromissos",
        "apps_installed_on_devices": "Aplicativos instalados em dispositivos",
        "astrological_signs": "Signos astrológicos",
        "audio_recordings": "Gravações de áudio",
        "auth_tokens": "Tokens de autenticação",
        "avatars": "Avatares",
        "bank_account_numbers": "Números de contas bancárias",
        "beauty_ratings": "Classificações de beleza",
        "biometric_data": "Dados biométricos",
        "bios": "Bios",
        "browser_user_agent_details": "Detalhes do agente do usuário do navegador",
        "browsing_histories": "Históricos de navegação",
        "buying_preferences": "Preferências de compra",
        "car_ownership_statuses": "Status de posse de veículo",
        "career_levels": "Níveis de carreira",
        "cellular_network_names": "Nomes de redes de telefonia celular",
        "charitable_donations": "Doações de caridade",
        "chat_logs": "Registros de bate-papo",
        "credit_card_cvv": "CVV do cartão de crédito",
        "credit_cards": "Cartões de crédito",
        "credit_status_information": "Informações sobre status de crédito",
        "customer_feedback": "Feedback de clientes",
        "customer_interactions": "Interações com clientes",
        "dates_of_birth": "Datas de nascimento",
        "deceased_date": "Data de falecimento",
        "deceased_statuses": "Status de falecimento",
        "device_information": "Informações do dispositivo",
        "device_serial_numbers": "Números de série do dispositivo",
        "device_usage_tracking_data": "Dados de rastreamento de uso do dispositivo",
        "drinking_habits": "Hábitos de consumo de bebidas",
        "driver_s_licenses": "Carteiras de motorista",
        "drug_habits": "Hábitos de droga",
        "eating_habits": "Hábitos alimentares",
        "education_levels": "Níveis de educação",
        "email_addresses": "Endereços de e-mail",
        "email_messages": "Mensagens de email",
        "employers": "Empregadores",
        "employment_statuses": "Status de emprego",
        "encrypted_keys": "Chaves criptografadas",
        "ethnicities": "Etnias",
        "family_members_names": "Nomes de membros da família",
        "family_plans": "Planos familiares",
        "family_structure": "Estrutura familiar",
        "financial_investments": "Investimentos financeiros",
        "financial_transactions": "Transações financeiras",
        "fitness_levels": "Níveis de condicionamento físico",
        "genders": "Gêneros",
        "geographic_locations": "Localizações geográficas",
        "government_issued_i_ds": "Identificações emitidas pelo governo",
        "health_insurance_information": "Informações de seguro de saúde",
        "historical_passwords": "Senhas históricas",
        "hiv_statuses": "Status de HIV",
        "home_loan_information": "Informações sobre empréstimo habitacional",
        "home_ownership_statuses": "Status de propriedade de imóvel",
        "homepage_ur_ls": "URLs da página inicial",
        "imei_numbers": "Números IMEI",
        "imsi_numbers": "Números IMSI",
        "income_levels": "Níveis de renda",
        "instant_messenger_identities": "Identidades de mensageiros instantâneos",
        "ip_addresses": "Endereços IP",
        "job_applications": "Candidaturas de emprego",
        "job_titles": "Títulos de cargos",
        "licence_plates": "Placas de matrícula",
        "living_costs": "Custos de vida",
        "login_histories": "Históricos de logins",
        "mac_addresses": "Endereços MAC",
        "marital_statuses": "Status marital",
        "mnemonic_phrases": "Frases mnemônicas",
        "mothers_maiden_names": "Nomes de solteira das mães",
        "names": "Nomes",
        "nationalities": "Nacionalidades",
        "net_worths": "Patrimônios líquidos",
        "nicknames": "Apelidos",
        "occupations": "Ocupações",
        "parenting_plans": "Planos parentais",
        "partial_credit_card_data": "Dados parciais do cartão de crédito",
        "partial_dates_of_birth": "Datas de nascimento parciais",
        "passport_numbers": "Números de passaporte",
        "password_hints": "Dicas de senha",
        "password_strengths": "Forças das senhas",
        "passwords": "Senhas",
        "payment_histories": "Históricos de pagamento",
        "payment_methods": "Métodos de pagamento",
        "personal_descriptions": "Descrições pessoais",
        "personal_health_data": "Dados de saúde pessoais",
        "personal_interests": "Interesses pessoais",
        "phone_numbers": "Números de telefone",
        "photos": "Fotos",
        "physical_addresses": "Endereços físicos",
        "physical_attributes": "Atributos físicos",
        "pi_ns": "PINs",
        "places_of_birth": "Locais de nascimento",
        "political_donations": "Doações políticas",
        "political_views": "Opiniões políticas",
        "private_messages": "Mensagens privadas",
        "professional_skills": "Habilidades profissionais",
        "profile_photos": "Fotos de perfil",
        "purchases": "Compras",
        "purchasing_habits": "Hábitos de compra",
        "races": "Raças",
        "recovery_email_addresses": "Endereços de e-mail de recuperação",
        "relationship_statuses": "Status de relacionamento",
        "religions": "Religiões",
        "reward_program_balances": "Saldos de programas de recompensas",
        "salutations": "Saudações",
        "school_grades_class_levels": "Notas escolares (níveis de classe)",
        "security_questions_and_answers": "Perguntas e respostas de segurança",
        "sexual_fetishes": "Fetiches sexuais",
        "sexual_orientations": "Orientações sexuais",
        "smoking_habits": "Hábitos de fumar",
        "sms_messages": "Mensagens SMS",
        "social_connections": "Conexões sociais",
        "social_media_profiles": "Perfis de redes sociais",
        "social_security_numbers": "Números de segurança social",
        "spoken_languages": "Idiomas falados",
        "spouses_names": "Nomes dos cônjuges",
        "support_tickets": "Tickets de suporte",
        "survey_results": "Resultados da pesquisa",
        "taxation_records": "Registros de tributação",
        "time_zones": "Fusos horários",
        "travel_habits": "Hábitos de viagem",
        "user_statuses": "Status do usuário",
        "user_website_ur_ls": "URLs de websites de usuários",
        "usernames": "Nomes de usuário",
        "utility_bills": "Contas de serviços públicos",
        "vehicle_details": "Detalhes do veículo",
        "website_activity": "Atividade do site",
        "work_habits": "Hábitos de trabalho",
        "years_of_professional_experience": "Anos de experiência profissional"
      }
    },
    "certificates": {
      "compliance": "Treinamento em Cibersegurança"
    },
    "courses": {
      "toc": {
        "breach-content": "Violações de datas",
        "file-content": "Baixar",
        "intro-content": "Introdução",
        "quiz-content": "Questionário",
        "text-content": "Caso",
        "video-content": "Vídeo"
      }
    },
    "locales": {
      "current": "português",
      "da_DK": "dinamarquês",
      "de_DE": "alemão",
      "en_US": "inglês",
      "es_ES": "Espanhol",
      "fi_FI": "finlandês",
      "fr_FR": "Francês",
      "nb_NO": "norueguês",
      "nl_NL": "holandês",
      "pl_PL": "polaco",
      "pt_PT": "português",
      "sv_SE": "sueco"
    },
    "onboarding": {
      "course": {
        "content": [
          {
            "attributes": {
              "description": "Saudações e bem-vindo à sua plataforma de aprendizagem personalizada! Estamos encantados por tê-lo conosco e ansiosos para ajudá-lo a alcançar seus objetivos de aprendizagem.",
              "title": "Bem-vindo ao Moxso"
            },
            "layout": "intro-content"
          },
          {
            "attributes": {
              "title": "Como a Moxso funciona",
              "video_id": "af422bc9-145b-4cf4-a9d4-de16a9dcbc61"
            },
            "layout": "video-content"
          },
          {
            "layout": "breach-content"
          }
        ],
        "id": "4a36d036-d378-449a-aa85-e62afd6e31f4",
        "image": "https://edge-cdn.moxso.com/course/4SuGbThgaOWPd69hzrD8oYqkwEkTvNzDMPEoHhrK.jpg",
        "title": "Vamos começar 🙌",
        "video": "https://edge-cdn.moxso.com/course/Tzk7FcRcvAHMlm35ACZNK4zIsRFvQGQimfpcKeCW.mp4"
      },
      "quiz_questions": {
        "data_privacy": {
          "category": "Conscientização sobre Privacidade de Dados",
          "options": {
            "high": "Familiarizado",
            "low": "Não familiarizado",
            "medium": "Algo familiarizado"
          },
          "question": "Quão familiarizado você está com os princípios básicos de privacidade de dados (por exemplo, GDPR)?"
        },
        "device_security": {
          "category": "Práticas de Segurança de Dispositivos",
          "options": {
            "high": "Sim, sempre",
            "low": "Não, nunca",
            "medium": "Às vezes"
          },
          "question": "Você atualiza regularmente seus dispositivos e usa ferramentas de segurança como um VPN?"
        },
        "digital_threats": {
          "category": "Conscientização sobre Ameaças Digitais",
          "options": {
            "high": "Familiarizado",
            "low": "Não familiarizado",
            "medium": "Algo familiarizado"
          },
          "question": "Quão familiarizado você está com ameaças digitais como malware, phishing e ransomware?"
        },
        "hybrid_work": {
          "category": "Segurança no Trabalho Remoto",
          "options": {
            "high": "Muito confiante",
            "low": "Não confiante",
            "medium": "Algo confiante"
          },
          "question": "Quão confiante você está em manter a segurança ao trabalhar remotamente (por exemplo, em Wi-Fi público)?"
        },
        "incidents_breaches": {
          "category": "Relatórios de Incidentes",
          "options": {
            "high": "Sim",
            "low": "Não",
            "medium": "Tenho uma ideia geral"
          },
          "question": "Você conhece o procedimento correto para relatar um incidente ou violação de segurança?"
        },
        "passwords_accounts": {
          "category": "Gestão de Senhas",
          "options": {
            "high": "Eu uso um gerenciador de senhas",
            "low": "Eu reutilizo senhas",
            "medium": "Eu crio senhas únicas e fortes"
          },
          "question": "Como você gerencia as senhas das suas contas relacionadas ao trabalho?"
        },
        "phishing": {
          "category": "Identificação de Phishing",
          "options": {
            "high": "Muito confiante",
            "low": "Não confiante",
            "medium": "Algo confiante"
          },
          "question": "Quão confiante você está em reconhecer tentativas de phishing em e-mails ou mensagens?"
        },
        "physical_security": {
          "category": "Práticas de Segurança Física",
          "options": {
            "high": "Sempre",
            "low": "Raramente",
            "medium": "Às vezes"
          },
          "question": "Com que frequência você garante a segurança do seu espaço de trabalho (por exemplo, trancando seu computador, armazenando documentos sensíveis)?"
        },
        "secure_browsing": {
          "category": "Hábitos de Navegação Segura",
          "options": {
            "high": "Sim, sempre",
            "low": "Não, nunca",
            "medium": "Às vezes"
          },
          "question": "Você evita usar Wi-Fi público ou clicar em links suspeitos enquanto navega?"
        }
      },
      "steps": {
        "finished": "Concluído",
        "introduction": "Introdução",
        "quiz": "Quiz"
      }
    },
    "partners": {
      "itf": "Fórum de TI"
    },
    "quiz": {
      "error": {
        "checksum": "Soma de verificação inválida",
        "option": "Resposta não reconhecida"
      },
      "intro": {
        "button": "Iniciar quiz",
        "text": "Vamos analisar 5 e-mails na sua caixa de entrada do Moxso. Alguns desses e-mails podem ser de golpistas tentando obter acesso a dados confidenciais - você precisa decidir se o e-mail é phishing ou não. Você está pronto?",
        "title": "Pronto para relatar?"
      },
      "multiple-choice": {
        "heading": "Encontre o erro neste e-mail",
        "text": "texto de ajuda de múltipla escolha"
      },
      "options": {
        "email": "O e-mail",
        "false": "Isso NÃO é Phishing",
        "help": {
          "email": "O remetente NÃO é confiável",
          "false": "O e-mail NÃO deve ser denunciado",
          "link": "O link NÃO leva a um destino confiável",
          "not-phishing": "Isso NÃO é phishing",
          "true": "O email deve ser denunciado"
        },
        "link": "O link",
        "not-phishing": "Isto NÃO é phishing",
        "true": "Isso É Phishing"
      },
      "title": "Quiz",
      "true-false": {
        "heading": "Este é um email de phishing?",
        "text": "Determine se este é um e-mail de phishing ou não"
      }
    },
    "training": {
      "training_restritions": {
        "course": {
          "description": "Não é possível aceder a este curso. Os cursos opcionais estão bloqueados, mas a formação obrigatória continua sempre disponível.",
          "title": "Este curso está bloqueado"
        },
        "quiz": {
          "description": "Atingiu o seu limite de formação. Os quizzes opcionais estão bloqueados por agora.",
          "title": "Limite de quizzes atingido"
        },
        "video": {
          "description": "Atingiu o seu limite de formação. Os vídeos opcionais estão bloqueados, mas a formação obrigatória continua sempre disponível.",
          "title": "Limite de vídeos atingido"
        }
      }
    },
    "training_restrictions": {
      "course": {
        "description": "Não é possível aceder a este curso. Os cursos opcionais estão bloqueados, mas a formação obrigatória continua sempre disponível.",
        "title": "Este curso está bloqueado"
      },
      "quiz": {
        "description": "Atingiu o seu limite de formação. Os quizzes opcionais estão bloqueados por agora.",
        "title": "Limite de quizzes atingido"
      },
      "reset": "Reinicia na segunda-feira",
      "video": {
        "description": "Atingiu o seu limite de formação. Os vídeos opcionais estão bloqueados, mas a formação obrigatória continua sempre disponível.",
        "limit_reached": "Limite atingido",
        "title": "Limite de vídeos atingido"
      }
    },
    "videos": {
      "category": {
        "advanced": {
          "text": "Avançado é uma série para aqueles que estão particularmente interessados em cibersegurança e querem entender como os mecanismos subjacentes em hacking e cibersegurança funcionam. Se você só quer ter um entendimento básico de cibersegurança, então não será necessário assistir aos vídeos desta série. Se você quer aprender mais sobre hacking, ciberataques e como melhorar sua cibersegurança da melhor forma, não procure mais.",
          "title": "Avançado",
          "tooltip": "Torne-se um especialista em hacking em pouco tempo"
        },
        "ai": {
          "text": "A série de IA explora em profundidade o papel complexo da inteligência artificial na cibersegurança. A IA desempenha uma função dupla: é uma ferramenta crucial para profissionais de segurança de TI identificarem e neutralizarem ameaças, mas também serve como um poderoso recurso nas mãos de hackers. Esta série de vídeos tem como objetivo aumentar a sua conscientização sobre golpes de phishing gerados por IA e orientá-lo sobre como usar a IA com segurança para minimizar erros e reduzir o risco de invasões. Em última análise, a série ressalta que, embora a IA seja uma ferramenta poderosa tanto para defensores quanto para atacantes, o seu comportamento continua sendo o fator-chave na sua segurança.",
          "title": "IA e cibersegurança",
          "tooltip": "Explore o papel complexo da IA na cibersegurança"
        },
        "compliance": {
          "text": "Esta categoria contém vídeos sobre legislação importante, padrões de segurança e certificações que podem ajudar a proteger seu local de trabalho contra ameaças digitais. Os vídeos oferecem insights sobre a Diretiva NIS2 e o Regulamento DORA, entre outros, que garantem medidas robustas de cibersegurança e conformidade com os padrões internacionais. Os vídeos fornecem uma visão sobre a importância das regulamentações, como alcançar a conformidade e os requisitos específicos que elas impõem à segurança e gestão de riscos das organizações. Você também entenderá o que as regulamentações significam para você e por que elas valem o seu tempo.",
          "title": "Certificações e conformidade",
          "tooltip": "Compreenda a importância das certificações e conformidade"
        },
        "gdpr": {
          "text": "RGPD (GDPR) é uma série que se debruça sobre as regras, requisitos e princípios estabelecidos no RGPD. O RGPD foi introduzido em 2018 e todas as empresas devem agora cumprir o RGPD para garantir a integridade e a proteção dos dados pessoais que processam. A série abrange as áreas mais relevantes do RGPD que precisa de conhecer para poder tratar corretamente os dados pessoais no seu dia a dia. Esta série inclui vídeos destinados a todos, incluindo funcionários do sector privado.",
          "title": "RGPD",
          "tooltip": "Aprenda os requisitos e regras mais importantes do RGDP e como você pode cumpri-los no seu dia a dia"
        },
        "hacking": {
          "text": "A vida de um hacker é uma série que ensina sobre as pessoas por trás dos ciberataques, os hackers do mundo. Vamos dar uma olhada mais de perto em alguns dos métodos que os hackers usam para permanecer anônimos online e como eles ganham seu dinheiro. Os vídeos explicarão ainda mais os diferentes tipos de hackers e por que eles são tão difíceis de capturar.",
          "title": "A vida de um hacker",
          "tooltip": "Conheça as pessoas por trás dos ciberataques, os hackers do mundo"
        },
        "money_laundering": {
          "text": "Lavagem de dinheiro é uma série que explora os diferentes métodos usados por criminosos para lavar dinheiro. Os vídeos explicarão os diferentes métodos usados por criminosos para lavar dinheiro e como detectar e prevenir a lavagem de dinheiro.",
          "title": "Lavagem de dinheiro",
          "tooltip": "Aprenda os diferentes métodos usados por criminosos para lavar dinheiro e como detectar e prevenir a lavagem de dinheiro"
        },
        "phishing": {
          "text": "Phishing é uma série que explora o ataque cibernético mais comum em todo o mundo. Os ataques de phishing podem ser tanto um ataque por si só quanto uma maneira de lançar outros ciberataques mais avançados. Além disso, os ataques de phishing são um tipo de ataque cibernético em que você, como empregado, é o único responsável por evitar ser hackeado, por exemplo, evitando clicar em um link em um e-mail. Phishing é uma área de foco essencial na cibersegurança e os vídeos nesta série fornecerão a você uma compreensão do phishing, de como é realizado pelos hackers e de como evitar se tornar uma vítima de um ataque de phishing.",
          "title": "Phishing",
          "tooltip": "Descubra os aspectos do tipo mais comum de ciberataque no mundo"
        },
        "physical_security": {
          "text": "Segurança Física é uma série que destaca a importância de uma boa segurança no local de trabalho e em casa. A cibersegurança é sobre mais do que a segurança dos seus dispositivos, é também sobre a segurança *em torno* dos dispositivos. Muitas pessoas estão familiarizadas com o trabalho remoto, e nós vamos equipá-lo para tornar isso o mais seguro possível. Além disso, com esta série, você obterá informações sobre tudo, desde a gestão de visitantes até a cibersegurança em dispositivos móveis e os riscos de usar redes públicas.",
          "title": "Segurança física",
          "tooltip": "Saiba por que a segurança física é um elemento crucial para uma boa segurança cibernética."
        },
        "tips_and_tricks": {
          "text": "Dicas e truques é uma série que ajudará a aumentar sua cibersegurança. Você aprenderá maneiras específicas e de baixa prática para aumentar sua segurança pessoal online e, consequentemente, aumentar a segurança no seu local de trabalho. Os vídeos explicarão ainda mais por que é importante lembrar dos conselhos sobre cibersegurança que você pode ter recebido no passado.",
          "title": "Dicas e truques",
          "tooltip": "Aprenda como aumentar sua cibersegurança pessoal"
        },
        "types_of_hacking": {
          "text": "Tipos de hacking é uma série que lhe proporciona insights sobre os diferentes métodos que os hackers têm à sua disposição quando tentam enganá-lo. Cada episódio oferece um entendimento básico das características de um método específico de hacking, o que os hackers podem ganhar ao usar esse método, as consequências que isso pode ter para você, se for hackeado, etc. Ao assistir aos vídeos desta série, você estará melhor preparado contra ataques de hacking no futuro.",
          "title": "Tipos de hacking",
          "tooltip": "Obtenha insights sobre os diferentes métodos utilizados por hackers"
        },
        "uploads": {
          "text": "Esta categoria contém vídeos personalizados enviados pela sua organização.",
          "title": "Uploads",
          "tooltip": "Assista a vídeos carregados pela sua organização para suas necessidades de segurança específicas"
        }
      }
    }
  },
  "error_page": {
    "error_has_been_reported": "Erro foi relatado à nossa equipe com o id: {errorId}. Se você precisar de assistência imediata, sinta-se à vontade para entrar em contato com nossa equipe de suporte em support{'@'}moxso.com.",
    "go_back": "Voltar para casa",
    "text": "Ocorreu um erro desconhecido e não foi possível completar seu pedido. Sentimos muito pelo inconveniente. Por favor, tente novamente mais tarde.",
    "title": "Algo deu errado"
  },
  "forms": {
    "fields": {
      "code": "Senha única",
      "email": "E-mail"
    },
    "placeholders": {
      "email": "nome{'@'}empresa.com"
    }
  },
  "loading": "Carregando",
  "locale": {
    "current": "Português",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "login": {
    "buttons": {
      "login": "Entrar",
      "next": "Próximo",
      "send_one_time_code": "Enviar código único",
      "try_again": "Reenviar código"
    },
    "choose_provider": "Escolher provedor",
    "loading": "Carregando",
    "sso": {
      "validating": "Validando SSO"
    },
    "title": "Conectar-se",
    "two_factor": {
      "text": "Enviámos uma senha única para o seu email.",
      "title": "Verifique seu e-mail"
    }
  },
  "mandatory": {
    "completed": {
      "text": "Você concluiu o conteúdo destacado que seu administrador escolheu para você.",
      "title": "Muito bem!"
    },
    "deadline": "Prazo de conclusão: {date}",
    "next_training": "Próximo treinamento atribuído",
    "policy_fallback_title": "Política",
    "quiz_questions": "{count} pergunta | {count} perguntas",
    "retake": "Reatribuído",
    "start_quiz": "Iniciar questionário",
    "text": "Seu treinamento atribuído",
    "title": "Treinamento atribuído",
    "view_policy": "Ver política"
  },
  "navigation": {
    "breaches": "Violações",
    "courses": "Cursos",
    "exit": "Sair",
    "exit_onboarding": "Pular integração",
    "login": "Entrar",
    "logout": "Sair",
    "onboarding": "Introdução",
    "onboarding_finished": "Onboarding concluído",
    "onboarding_intro": "Introdução ao onboarding",
    "onboarding_quiz": "Quiz de onboarding",
    "overview": "Visão Geral",
    "simulation_click": "Simulação de phishing",
    "simulations": "Simulações",
    "videos": "Vídeos"
  },
  "overview": {
    "start_quiz": "Iniciar um Questionário",
    "welcome": "Bem-vindo de volta"
  },
  "partner_text": "A plataforma Moxso é apresentada em colaboração com {partner}.",
  "policies": {
    "cancel": {
      "text": "Esta política foi cancelada pelo seu administrador.",
      "title": "Política cancelada"
    },
    "continue": "Continuar",
    "expired": {
      "text": "Esta política expirou e já não está disponível.",
      "title": "Política expirada"
    },
    "focus": "Foco",
    "history": {
      "count": "{count} assinadas",
      "show_less": "Mostrar menos",
      "signed": "Assinada: {date}",
      "subtitle": "Reveja as políticas que já assinou.",
      "title": "Políticas assinadas",
      "view_more": "Mostrar mais"
    },
    "next": "Próximo",
    "overview": "Visão geral do conteúdo",
    "policy": "Política",
    "quiz": {
      "confirmation_card_locked": "Você deve concluir o quiz para continuar",
      "subtitle": "Verifique sua compreensão da política respondendo a este quiz.",
      "subtitle_completed": "Você concluiu o quiz. Confirme a leitura da política para terminar.",
      "title": "Quiz",
      "title_completed": "Quiz concluído"
    },
    "reader": "Modo de Leitura",
    "signature": {
      "button": "Aprovar",
      "checkbox_label": "Eu li a política",
      "company": "Empresa",
      "completed": {
        "button": "Terminar",
        "policy_completed": "Política aceita",
        "subtitle": "Muito bem! Você aceitou a política.",
        "title": "Política aceita"
      },
      "ip_adress": "Endereço IP",
      "subtitle": "Ao confirmar, você reconhece que leu e entendeu a política.",
      "title": "Confirmar leitura da política",
      "user_agent": "Agente de usuário"
    },
    "this_policy_doesnt_exist_in_this_language": "Esta política não está disponível em inglês. Exibindo a versão em {locale}."
  },
  "quiz": {
    "analyze": {
      "text": "Analise este e-mail e obtenha ajuda.",
      "title": "Em dúvida?"
    },
    "feedback": {
      "no": "Não",
      "text": "Esta página foi útil?",
      "thanks": "Obrigado pelo seu feedback!",
      "yes": "Sim"
    },
    "help": {
      "button": "Próxima pergunta",
      "text": "Analisamos o e-mail e encontramos o seguinte resultado",
      "title": "Análise de email"
    },
    "intro": {
      "button": "Iniciar questionário",
      "text": "Vamos analisar 5 e-mails na sua caixa de entrada do Moxso. Alguns dos e-mails podem ser de golpistas tentando obter acesso a dados sensíveis - você deve decidir se o e-mail é phishing ou não. Você está pronto?",
      "title": "Pronto para relatar?"
    },
    "preview": "Pré-visualização de email",
    "question": "Pergunta {current} de {total}",
    "result": {
      "go_back": "Ir para a sua visão geral",
      "mails": "E-mail avistado | E-mails avistados",
      "points": "Pontos ganhos",
      "text": {
        "bad": "Infelizmente, você só categorizou {count} email corretamente. Mas lembre-se: A prática leva à perfeição! | Infelizmente, você só categorizou {count} emails corretamente. Mas lembre-se: A prática leva à perfeição!",
        "good": "Você categorizou {count} emails corretamente e completou o quiz. Continue com o bom trabalho!"
      },
      "title": {
        "bad": "Melhor sorte na próxima vez",
        "good": "Muito bem!"
      }
    },
    "title": "Quiz"
  },
  "resilience_score": {
    "long_text": "A pontuação de resiliência mede a sua capacidade de resistir a ataques cibernéticos. A pontuação é calculada com base no seu comportamento em questionários, vídeos, simulações e nas suas competências. Quanto mais elevada for a sua pontuação de resiliência, melhor será a sua proteção e a proteção do seu local de trabalho contra os ciberataques.",
    "quizzing": {
      "text": "Melhore seu desempenho em quizzes de múltipla escolha para fortalecer sua resiliência.",
      "title": "Questionários"
    },
    "show_breakdown": "Exibir detalhamento",
    "simulations": {
      "text": "Um comportamento seguro em relação a phishing melhora sua resiliência. Não clique e lembre-se de reportar!",
      "title": "Simulações"
    },
    "skills": {
      "text": "Suas habilidades dependem de como você se sai em testes. Respostas corretas aumentam a resiliência.",
      "title": "Habilidades"
    },
    "text": "A pontuação de resiliência mede sua capacidade de resistir a ciberataques.",
    "title": "A sua pontuação de resiliência",
    "videos": {
      "text": "Os vídeos são uma parte importante do seu treinamento. Aumente a resiliência assistindo a vídeos.",
      "title": "Vídeos"
    }
  },
  "search": {
    "empty": "Pesquise algo para começar...",
    "no_results": "Nenhum resultado encontrado",
    "placeholder": "Pesquisar...",
    "popular": "Pesquisas populares",
    "popular_terms": ["Ransomware", "Engenharia Social"]
  },
  "simulation": {
    "alert": {
      "text": "Este email faz parte de um exercício automatizado de phishing, mas não se preocupe, é apenas um teste.",
      "title": "Esta é uma simulação de phishing"
    },
    "baseline": {
      "text": "Atualmente, estamos testando os seus colegas. Pedimos gentilmente que você não compartilhe esta mensagem.",
      "title": "Consegue Guardar um Segredo?"
    },
    "branding": {
      "text": "Estamos aqui para ajudar, portanto, não hesite em entrar em contato.",
      "title": "Este exercício foi entregue por Moxso"
    },
    "delivered_by": {
      "text": "Este exercício foi entregue pela Moxso em nome de {companyName}. Se você tiver alguma dúvida, sinta-se à vontade para entrar em contato com {contactEmail}.",
      "title": "Sobre este exercício"
    },
    "preview": "Visualização de email",
    "resilience_score": {
      "text": "Seu índice de resiliência mede sua capacidade de resistir a ciberataques.",
      "title": "Seu score de resiliência"
    },
    "submission": {
      "text": "Você clicou em um link e acessou uma página falsa, mas convincente. Em um ataque real de phishing, suas credenciais poderiam ter sido roubadas. Felizmente, isso foi apenas um teste.",
      "title": "O que acabou de acontecer?"
    },
    "training": {
      "button": "Inicie seu treinamento"
    }
  },
  "simulations": {
    "count": "Você recebeu {count} simulações pela Moxso nos últimos 90 dias.",
    "empty": {
      "text": "Você não recebeu nenhuma simulação nos últimos 90 dias.",
      "title": "Nenhuma simulação encontrada"
    },
    "joined": "Ingressou no programa de treinamento Moxso",
    "title": "Simulações",
    "tooltip": {
      "click": "Você clicou no link desta simulação.",
      "report": "Você reportou esta simulação.",
      "submit": "Você entrou nesta simulação."
    }
  },
  "sso": {
    "login_with": "Continue com {provider}",
    "or": "ou use .sso.or",
    "redirect": "Redirecionando"
  },
  "statistics": {
    "leaderboard": "Tabela de classificação",
    "missing_data": {
      "text": "Você precisa ganhar pontos para ver sua posição no ranking",
      "title": "Ganhe pontos para ver sua classificação"
    },
    "points_earned": "{count} pontos ganhos",
    "resilience_score": "Pontuação de resiliência"
  },
  "videos": {
    "error": "O streaming está atualmente indisponível",
    "latest": "Vídeos mais recentes",
    "more": "Ver mais",
    "not_available_in_your_locale": "Este vídeo não está disponível em inglês. Mudamos automaticamente para um idioma diferente.",
    "play": "Reproduzir vídeo",
    "quiz": {
      "resume": "Retomar questionário",
      "title": "Questionário"
    },
    "related": "Vídeos relacionados",
    "related_videos": "Vídeos sugeridos",
    "title": "Vídeos",
    "watch_again": "Assistir novamente"
  }
}
